import { render, staticRenderFns } from "./WechatAuthorize.vue?vue&type=template&id=01a7cf3b"
import script from "./WechatAuthorize.vue?vue&type=script&lang=js"
export * from "./WechatAuthorize.vue?vue&type=script&lang=js"
import style0 from "./WechatAuthorize.vue?vue&type=style&index=0&id=01a7cf3b&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports